import { render } from "./DisabilityPage.vue?vue&type=template&id=cd3bbd6e&scoped=true"
import script from "./DisabilityPage.vue?vue&type=script&lang=js"
export * from "./DisabilityPage.vue?vue&type=script&lang=js"

import "./DisabilityPage.vue?vue&type=style&index=0&id=cd3bbd6e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd3bbd6e"]])

export default __exports__